import React, { useState } from 'react';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { useNavigate } from 'react-router-dom';

const ClearData = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState('');

  const clearAllData = () => {
    try {
      // Clear all localStorage
      localStorage.clear();
      setMessage('✅ All data cleared successfully! Login again to reinitialize with admin@rubiconfinservices.com');
      
      // Redirect to login after 3 seconds
      setTimeout(() => {
        navigate('/admin/login');
      }, 3000);
    } catch (error) {
      setMessage('❌ Error clearing data: ' + error.message);
    }
  };

  const checkCurrentData = () => {
    try {
      const users = localStorage.getItem('rubicon_users');
      if (users) {
        const parsed = JSON.parse(users);
        const emails = parsed.map(u => u.email).join(', ');
        setMessage(`Current admin emails in localStorage: ${emails}`);
      } else {
        setMessage('No user data found in localStorage.');
      }
    } catch (error) {
      setMessage('Error reading data: ' + error.message);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>Clear Old Admin Data</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="bg-yellow-50 border border-yellow-200 rounded p-4 text-sm">
            <p className="font-semibold text-yellow-900 mb-2">⚠️ Clear Browser Data:</p>
            <p className="text-yellow-800">
              If you're seeing old data or login issues, click "Clear All Data" below.
            </p>
            <p className="text-yellow-800 mt-2">
              Current admin email: <strong>admin@rubiconfinservices.com</strong>
            </p>
          </div>

          <div className="space-y-2">
            <Button 
              onClick={checkCurrentData}
              variant="outline"
              className="w-full"
            >
              Check Current Data
            </Button>

            <Button 
              onClick={clearAllData}
              className="w-full bg-red-600 hover:bg-red-700"
            >
              Clear All Data
            </Button>
          </div>

          {message && (
            <div className={`p-3 rounded text-sm ${
              message.includes('✅') ? 'bg-green-50 text-green-800' : 
              message.includes('❌') ? 'bg-red-50 text-red-800' : 
              'bg-blue-50 text-blue-800'
            }`}>
              {message}
            </div>
          )}

          <div className="text-xs text-slate-500 space-y-1">
            <p><strong>Note:</strong> This will clear:</p>
            <ul className="list-disc list-inside ml-2">
              <li>All proposals</li>
              <li>All users</li>
              <li>Login session</li>
            </ul>
            <p className="mt-2">After clearing, you'll be redirected to login page.</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ClearData;
